export const allPositions = {
  D1: [
    {
      position: 'QBDT',
      feet: 6,
      inches: 4,
      weight: 220,
      t40: 4.5,
      description: '',
    },
    {
      position: 'QBPS',
      feet: 6,
      inches: 4,
      weight: 220,
      t40: 4.9,
      description: '',
    },
    {
      position: 'WR',
      feet: 6,
      inches: 2,
      weight: 190,
      t40: 4.5,
      description: '',
    },
    {
      position: 'SR',
      feet: 6,
      inches: 0,
      weight: 190,
      t40: 4.5,
      description: '',
    },
    {
      position: 'RB',
      feet: 6,
      inches: 0,
      weight: 210,
      t40: 4.4,
      description: '',
    },
    {
      position: 'FB',
      feet: 6,
      inches: 0,
      weight: 230,
      t40: 4.6,
      description: '',
    },
    {
      position: 'HB',
      feet: 6,
      inches: 4,
      weight: 230,
      t40: 4.7,
      description: '',
    },
    {
      position: 'TE',
      feet: 6,
      inches: 4,
      weight: 230,
      t40: 4.7,
      description: '',
    },
    {
      position: 'C',
      feet: 6,
      inches: 5,
      weight: 280,
      t40: 5,
      description: '',
    },
    {
      position: 'OG',
      feet: 6,
      inches: 6,
      weight: 280,
      t40: 5,
      description: '',
    },
    {
      position: 'OT',
      feet: 6,
      inches: 7,
      weight: 280,
      t40: 5,
      description: '',
    },
    {
      position: 'DT',
      feet: 6,
      inches: 4,
      weight: 270,
      t40: 4.8,
      description: '',
    },
    {
      position: 'DE',
      feet: 6,
      inches: 4,
      weight: 230,
      t40: 4.6,
      description: '',
    },
    {
      position: 'ML',
      feet: 6,
      inches: 2,
      weight: 220,
      t40: 4.6,
      description: '',
    },
    {
      position: 'OL',
      feet: 6,
      inches: 2,
      weight: 220,
      t40: 4.6,
      description: '',
    },
    {
      position: 'DB',
      feet: 6,
      inches: 0,
      weight: 185,
      t40: 4.5,
      description: '',
    },
    {
      position: 'SS',
      feet: 6,
      inches: 2,
      weight: 200,
      t40: 4.6,
      description: '',
    },
    {
      position: 'FS',
      feet: 6,
      inches: 2,
      weight: 190,
      t40: 4.6,
      description: '',
    },
    {
      position: 'K',
      feet: 6,
      inches: 2,
      weight: 190,
      t40: 5,
      description: 'Kick Offs D1 FBS Avg. Distance,65 Yards Longest,70+ Yards Avg. Hang Time,3.8 seconds Best Hang Time,4.3 seconds Field Goals D1 FBS/FCS/JUCO Hit 3 to 5 FG’s from long range (55-60 yards)',
    },
    {
      position: 'P',
      feet: 6,
      inches: 2,
      weight: 190,
      t40: 5,
      description: 'D1 FBS Avg. Distance,48 Yards Longest,60 Yards Avg. Hang Time,4.6 seconds Best Hang Time,5.0+ seconds',
    },
    {
      position: 'LS',
      feet: 6,
      inches: 5,
      weight: 260,
      t40: 5,
      description: 'FBS       .65 to .70 seconds        100% within 10 inches of target\n80% On Target 15 Yard Snap Average Time Accuracy',
    },
  ],
  JUCO: [
    {
      position: 'QBDT',
      feet: 6,
      inches: 2,
      weight: 200,
      t40: 4.6,
      description: '',
    },
    {
      position: 'QBPS',
      feet: 6,
      inches: 2,
      weight: 200,
      t40: 5,
      description: '',
    },
    {
      position: 'WR',
      feet: 6,
      inches: 0,
      weight: 175,
      t40: 4.6,
      description: '',
    },
    {
      position: 'SR',
      feet: 6,
      inches: 0,
      weight: 175,
      t40: 4.6,
      description: '',
    },
    {
      position: 'RB',
      feet: 5,
      inches: 11,
      weight: 195,
      t40: 4.5,
      description: '',
    },
    {
      position: 'FB',
      feet: 5,
      inches: 11,
      weight: 215,
      t40: 4.7,
      description: '',
    },
    {
      position: 'HB',
      feet: 6,
      inches: 3,
      weight: 220,
      t40: 4.8,
      description: '',
    },
    {
      position: 'TE',
      feet: 6,
      inches: 3,
      weight: 220,
      t40: 4.8,
      description: '',
    },
    {
      position: 'C',
      feet: 6,
      inches: 2,
      weight: 270,
      t40: 5.2,
      description: '',
    },
    {
      position: 'OG',
      feet: 6,
      inches: 4,
      weight: 270,
      t40: 5.2,
      description: '',
    },
    {
      position: 'OT',
      feet: 6,
      inches: 6,
      weight: 270,
      t40: 5.2,
      description: '',
    },
    {
      position: 'DT',
      feet: 6,
      inches: 3,
      weight: 250,
      t40: 4.9,
      description: '',
    },
    {
      position: 'DE',
      feet: 6,
      inches: 3,
      weight: 230,
      t40: 4.7,
      description: '',
    },
    {
      position: 'ML',
      feet: 6,
      inches: 1,
      weight: 210,
      t40: 4.65,
      description: '',
    },
    {
      position: 'OL',
      feet: 6,
      inches: 1,
      weight: 210,
      t40: 4.65,
      description: '',
    },
    {
      position: 'DB',
      feet: 6,
      inches: 0,
      weight: 185,
      t40: 4.6,
      description: '',
    },
    {
      position: 'SS',
      feet: 6,
      inches: 1,
      weight: 190,
      t40: 4.6,
      description: '',
    },
    {
      position: 'FS',
      feet: 6,
      inches: 1,
      weight: 190,
      t40: 4.6,
      description: '',
    },
    {
      position: 'K',
      feet: 6,
      inches: 0,
      weight: 175,
      t40: 5,
      description: 'Kick Offs JUCO Avg. Distance, 62 Yards Longest, 65+ Yards Avg. Hang Time, 3.6 seconds Best Hang Time, 4.1+ seconds',
    },
    {
      position: 'P',
      feet: 6,
      inches: 0,
      weight: 175,
      t40: 5,
      description: 'JUCO Avg. Distance, 45 Yards Longest, 55 Yards Avg. Hang Time, 4.4 seconds Best Hang Time,  4.85 seconds',
    },
    {
      position: 'LS',
      feet: 6,
      inches: 3,
      weight: 250,
      t40: 5.2,
      description: 'JUCO .70 to .75 seconds 100% within 10 inches of target  80% On Target 15 Yard Snap Average Time Accuracy',
    },
  ],
  D2: [
    {
      position: 'QBDT',
      feet: 6,
      weight: 200,
      inches: 0,
      t40: 4.7,
      Description: '',
    },
    {
      position: 'QBPS',
      feet: 6,
      weight: 200,
      inches: 0,
      t40: 5,
      Description: '',
    },
    {
      position: 'WR',
      feet: 5,
      weight: 165,
      inches: 10,
      t40: 4.6,
      Description: '',
    },
    {
      position: 'SR',
      feet: 5,
      weight: 165,
      inches: 10,
      t40: 4.6,
      Description: '',
    },
    {
      position: 'RB',
      feet: 5,
      weight: 175,
      inches: 10,
      t40: 4.6,
      Description: '',
    },
    {
      position: 'FB',
      feet: 5,
      weight: 195,
      inches: 10,
      t40: 4.6,
      Description: '',
    },
    {
      position: 'HB',
      feet: 6,
      weight: 215,
      inches: 2,
      t40: 4.85,
      Description: '',
    },
    {
      position: 'TE',
      feet: 6,
      weight: 215,
      inches: 2,
      t40: 4.85,
      Description: '',
    },
    {
      position: 'C',
      feet: 6,
      weight: 260,
      inches: 1,
      t40: 5.3,
      Description: '',
    },
    {
      position: 'OG',
      feet: 6,
      weight: 260,
      inches: 3,
      t40: 5.3,
      Description: '',
    },
    {
      position: 'OT',
      feet: 6,
      weight: 260,
      inches: 5,
      t40: 5.3,
      Description: '',
    },
    {
      position: 'DT',
      feet: 6,
      weight: 240,
      inches: 2,
      t40: 5,
      Description: '',
    },
    {
      position: 'DE',
      feet: 6,
      weight: 220,
      inches: 2,
      t40: 4.8,
      Description: '',
    },
    {
      position: 'ML',
      feet: 6,
      weight: 200,
      inches: 0,
      t40: 4.7,
      Description: '',
    },
    {
      position: 'OL',
      feet: 6,
      weight: 200,
      inches: 0,
      t40: 4.7,
      Description: '',
    },
    {
      position: 'DE',
      feet: 5,
      weight: 175,
      inches: 10,
      t40: 4.65,
      Description: '',
    },
    {
      position: 'SS',
      feet: 5,
      weight: 185,
      inches: 11,
      t40: 4.7,
      Description: '',
    },
    {
      position: 'FS',
      feet: 5,
      weight: 185,
      inches: 11,
      t40: 4.7,
      Description: '',
    },
    {
      position: 'K',
      feet: 5,
      weight: 165,
      inches: 10,
      t40: 5,
      Description: 'Kick Offs Division 2        Avg. Distance,60+ Yards        Longest,65 Yards Avg. Hang Time,3.5 seconds        Best Hang Time,4.0+ seconds\nField Goals D2/NAIA   Hit 3 to 5 FG’s from medium-long range (45 yards)',
    },
    {
      position: 'P',
      feet: 5,
      weight: 165,
      inches: 10,
      t40: 5,
      Description: 'Division 2        Avg. Distance,43 Yards           Longest,53 Yards        Avg. Hang Time,4.2 seconds        Best Hang Time,4.75 seconds',
    },
    {
      position: 'LS',
      feet: 6,
      weight: 240,
      inches: 1,
      t40: 5.3,
      Description: 'Division 2        .75 to .78 seconds        80% within 10 inches of target\n60% On Target 15 Yard Snap Average Time Accuracy',
    },
  ],
  NAIA: [
    {
      position: 'QBDT',
      feet: 6,
      inches: 0,
      weight: 200,
      t40: 4.7,
      description: '',
    },
    {
      position: 'QBPS',
      feet: 6,
      inches: 0,
      weight: 200,
      t40: 5,
      description: '',
    },
    {
      position: 'WR',
      feet: 5,
      inches: 10,
      weight: 165,
      t40: 4.6,
      description: '',
    },
    {
      position: 'SR',
      feet: 5,
      inches: 10,
      weight: 165,
      t40: 4.6,
      description: '',
    },
    {
      position: 'RB',
      feet: 5,
      inches: 10,
      weight: 175,
      t40: 4.6,
      description: '',
    },
    {
      position: 'FB',
      feet: 5,
      inches: 10,
      weight: 195,
      t40: 4.6,
      description: '',
    },
    {
      position: 'HB',
      feet: 6,
      inches: 2,
      weight: 215,
      t40: 4.85,
      description: '',
    },
    {
      position: 'TE',
      feet: 6,
      inches: 2,
      weight: 215,
      t40: 4.85,
      description: '',
    },
    {
      position: 'C',
      feet: 6,
      inches: 1,
      weight: 260,
      t40: 5.3,
      description: '',
    },
    {
      position: 'OG',
      feet: 6,
      inches: 3,
      weight: 260,
      t40: 5.3,
      description: '',
    },
    {
      position: 'OT',
      feet: 6,
      inches: 5,
      weight: 260,
      t40: 5.3,
      description: '',
    },
    {
      position: 'DT',
      feet: 6,
      inches: 2,
      weight: 240,
      t40: 5,
      description: '',
    },
    {
      position: 'DE',
      feet: 6,
      inches: 2,
      weight: 220,
      t40: 4.8,
      description: '',
    },
    {
      position: 'ML',
      feet: 6,
      inches: 0,
      weight: 200,
      t40: 4.7,
      description: '',
    },
    {
      position: 'OL',
      feet: 6,
      inches: 0,
      weight: 200,
      t40: 4.7,
      description: '',
    },
    {
      position: 'DE',
      feet: 5,
      inches: 10,
      weight: 175,
      t40: 4.65,
      description: '',
    },
    {
      position: 'SS',
      feet: 5,
      inches: 11,
      weight: 185,
      t40: 4.7,
      description: '',
    },
    {
      position: 'FS',
      feet: 5,
      inches: 11,
      weight: 185,
      t40: 4.7,
      description: '',
    },
    {
      position: 'K',
      feet: 5,
      inches: 10,
      weight: 165,
      t40: 5,
      description: 'Kick Offs NAIA        Avg. Distance,60+ Yards        Longest,65 Yards Avg. Hang Time,3.5 seconds        Best Hang Time,4.0+ seconds\nField Goals D2/NAIA   Hit 3 to 5 FG’s from medium-long range (45 yards)',
    },
    {
      position: 'P',
      feet: 5,
      inches: 10,
      weight: 165,
      t40: 5,
      description: 'NAIA            Avg. Distance,43 Yards           Longest,53 Yards        Avg. Hang Time,4.2 seconds        Best Hang Time,4.75 seconds',
    },
    {
      position: 'LS',
      feet: 6,
      inches: 1,
      weight: 240,
      t40: 5.3,
      description: 'NAIA        .75 to .78 seconds        80% within 10 inches of target\n60% On Target 15 Yard Snap Average Time Accuracy',
    },
  ],
  D3: [
    {
      position: 'QBDT',
      feet: 6,
      inches: 0,
      weight: 200,
      t40: 4.7,
      description: '',
    },
    {
      position: 'QBPS',
      feet: 6,
      inches: 0,
      weight: 200,
      t40: 5,
      description: '',
    },
    {
      position: 'WR',
      feet: 5,
      inches: 10,
      weight: 165,
      t40: 4.6,
      description: '',
    },
    {
      position: 'SR',
      feet: 5,
      inches: 10,
      weight: 165,
      t40: 4.6,
      description: '',
    },
    {
      position: 'RB',
      feet: 5,
      inches: 10,
      weight: 175,
      t40: 4.6,
      description: '',
    },
    {
      position: 'FB',
      feet: 5,
      inches: 10,
      weight: 195,
      t40: 4.6,
      description: '',
    },
    {
      position: 'HB',
      feet: 6,
      inches: 2,
      weight: 215,
      t40: 4.85,
      description: '',
    },
    {
      position: 'TE',
      feet: 6,
      inches: 2,
      weight: 215,
      t40: 4.85,
      description: '',
    },
    {
      position: 'C',
      feet: 6,
      inches: 1,
      weight: 260,
      t40: 5.3,
      description: '',
    },
    {
      position: 'OG',
      feet: 6,
      inches: 3,
      weight: 260,
      t40: 5.3,
      description: '',
    },
    {
      position: 'OT',
      feet: 6,
      inches: 5,
      weight: 260,
      t40: 5.3,
      description: '',
    },
    {
      position: 'DT',
      feet: 6,
      inches: 2,
      weight: 240,
      t40: 5,
      description: '',
    },
    {
      position: 'DE',
      feet: 6,
      inches: 2,
      weight: 220,
      t40: 4.8,
      description: '',
    },
    {
      position: 'ML',
      feet: 6,
      inches: 0,
      weight: 200,
      t40: 4.7,
      description: '',
    },
    {
      position: 'OL',
      feet: 6,
      inches: 0,
      weight: 200,
      t40: 4.7,
      description: '',
    },
    {
      position: 'DE',
      feet: 5,
      inches: 10,
      weight: 175,
      t40: 4.65,
      description: '',
    },
    {
      position: 'SS',
      feet: 5,
      inches: 11,
      weight: 185,
      t40: 4.7,
      description: '',
    },
    {
      position: 'FS',
      feet: 5,
      inches: 11,
      weight: 185,
      t40: 4.7,
      description: '',
    },
    {
      position: 'K',
      feet: 5,
      inches: 10,
      weight: 165,
      t40: 5,
      description: 'Kick Offs NAIA        Avg. Distance,60+ Yards        Longest,65 Yards Avg. Hang Time,3.5 seconds        Best Hang Time,4.0+ seconds\nField Goals D2/NAIA   Hit 3 to 5 FG’s from medium-long range (45 yards)',
    },
    {
      position: 'P',
      feet: 5,
      inches: 10,
      weight: 165,
      t40: 5,
      description: 'NAIA            Avg. Distance,43 Yards           Longest,53 Yards        Avg. Hang Time,4.2 seconds        Best Hang Time,4.75 seconds',
    },
    {
      position: 'LS',
      feet: 6,
      inches: 1,
      weight: 240,
      t40: 5.3,
      description: 'NAIA        .75 to .78 seconds        80% within 10 inches of target\n60% On Target 15 Yard Snap Average Time Accuracy',
    },
  ],
};

export const abc = {};



// WEBPACK FOOTER //
// ./src/common/constants/postingData.js